// Dependencies
import React, { Component } from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

// Styles
import "./SearchUsers.component.scss";
import { boolean } from "yup";

export interface SearchUsersProps {
    onSearch: any;
    isLoading: boolean;
}
export interface SearchUsersState {}

export default class SearchUsers extends Component<
    SearchUsersProps,
    SearchUsersState
> {
    constructor(props) {
        super(props);
    }

    focusSearch = e => {
        e.stopPropagation();
    };

    onChange = e => {
        this.props.onSearch(e.target.value);
    };

    render() {
        return (
            <div className="search-users-container">
                <input
                    placeholder="Search Users..."
                    onChange={this.onChange}
                    onClick={this.focusSearch}
                />
                {this.props.isLoading && (
                    <Components.LoadingRipple width={"30px"} height={"30px"} />
                )}
            </div>
        );
    }
}
